(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('NewFeature', NewFeature);

    NewFeature.$inject = ['$resource', 'DateUtils'];

    function NewFeature ($resource, DateUtils) {
        var resourceUrl =  'api/new-features/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': { 
                method:'PUT'
            },
            'save': {
                method: 'POST'
            },
            'getForUser': {
                method: 'GET',
                url: '/api/new-features/user',
                isArray: true
            },
            'markViewed': {
                url: '/api/new-features/:id/mark-as-viewed',
                method: 'POST'
            }
        });
    }

})();
